import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      toast.error('Google sign-in failed: missing session');
      navigate('/login', { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API}/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        await checkAuth();
        toast.success(`Welcome, ${data.name}!`);
        // Clean the URL hash and go to home
        navigate('/', { replace: true, state: { user: data } });
      } catch (error) {
        const detail = error.response?.data?.detail || 'Sign-in failed';
        toast.error(typeof detail === 'string' ? detail : 'Sign-in failed');
        navigate('/login', { replace: true });
      }
    })();
  }, [location.hash, navigate, checkAuth]);

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: '#F9F6F0' }}
      data-testid="auth-callback"
    >
      <div className="text-center">
        <div
          className="text-3xl mb-2 tracking-tight"
          style={{ fontFamily: 'Cormorant Garamond', fontWeight: 600, color: '#1A1A1A' }}
        >
          Signing you in...
        </div>
        <p style={{ fontFamily: 'Manrope', color: '#5C5C5C' }}>
          Please wait while we finish authenticating with Google.
        </p>
      </div>
    </div>
  );
};
